import { combineReducers } from 'redux';
import { AuthenticationState } from "./state";
import { loadStoredTokenReducer } from "../usecases/loadStoredToken/reducer";
import { sendLoginConfirmationCodeReducer } from "../usecases/confirmation/reducer";

export const authenticationRootReducer = combineReducers<AuthenticationState>({
    token       : loadStoredTokenReducer,
    confirmation: sendLoginConfirmationCodeReducer
})
